export class RegisterUser {
  constructor(
    private email?: string | null,
    private password?: string | null,
    private firstname?: string | null,
    private lastname?: string | null,
    private gender?: string | null,
    private termsAndConditionsAccepted?: boolean | null ) {
  }
}
